import PlaceholderPage from './_PlaceholderPage.jsx'

export default function SettingsPage() {
  return (
    <PlaceholderPage
      title="Settings"
      sub="API keys, runtime tokens, account."
    />
  )
}
